<template>
  <div class="textFont">
    <b-button
      v-b-modal="'Modal' + questionId + '_' + surveyType"
      class="float-right"
      size="sm"
      variant="link"
      @click="getResponseHistory()"
    >
      History
      <b-icon icon="clock-history"></b-icon>
    </b-button>
    <b-modal :id="'Modal' + questionId + '_' + surveyType" size="xl" title="Response History">
      <div v-if="loading" class="text-center">
        <b-spinner variant="secondary"></b-spinner>
      </div>
      <div v-else class="container textFont">
        <b-table-simple v-if="responseHistory.length > 0" hover responsive>
          <b-thead>
            <b-tr>
              <b-th>Updated On</b-th>
              <b-th>Updated By</b-th>
              <b-th>Latest Value</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(value, key) in responseHistory" :key="key">
              <b-td>{{ showTime(value['Created_Date__c']) }}</b-td>
              <b-td v-if="value['Created_by_Portal_User__r']"
                >{{ value['Created_by_Portal_User__r'].Name }}
              </b-td>
              <b-td v-else>Admin</b-td>

              <b-td v-if="type === 'document'">
                <b-row> {{ value['New_Value__c'] }}</b-row>
              </b-td>
              <b-td v-else-if="type === 'static' || type === 'multiPicklist'">
                <ul v-if="!value.isEmpty">
                  <li v-for="(value, key) in value['New_Value__c']" :key="key">
                    {{ value }}
                  </li>
                </ul>
              </b-td>
              <b-td v-else>{{ value['New_Value__c'] }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <p v-if="!responseHistory.length > 0" class="text-center">
          No response history found for this survey.
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button class="justify-content-center" variant="primary" @click="cancel()"> OK</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import moment from 'moment-timezone';
  import _ from 'lodash';

  export default {
    props: {
      questionId: { type: String },
      type: { type: String },
      surveyType: { type: String },
      options: { type: Array },
      rows: { type: Number },
    },
    data() {
      return {
        responseObject: {},
        responseHistory: [],
        loading: false,
        finalData: [],
        specialTypes: ['document', 'multiPicklist', 'static'],
      };
    },
    computed: {
      url() {
        let eventId = this.$route.params.eventId;
        return `${eventId}/${this.questionId}`;
      },
    },
    methods: {
      async getResponseHistory() {
        this.loading = true;
        await axios
          .get(`/api/get-response-history/${this.url}`)
          .then(response => {
            this.responseHistory = _.sortBy(response.data['records'], 'Created_Date__c').reverse();
            if (this.specialTypes.includes(this.type)) {
              this[this.type]();
            }
          })
          .catch(error => {
            this.handleError(error);
          });
        this.loading = false;
      },
      handleError(error) {
        this.$bvModal.hide('Modal' + this.questionId + '_' + this.surveyType);
        let code;
        if ('response' in error) {
          code = error.response.status;
        } else {
          code = 'Failed';
        }
        this.$bvToast.toast(
          `Something went wrong while fetching the response history, please contact the support team`,
          {
            title: `Error code: ${code}`,
            autoHideDelay: 5000,
            appendToast: true,
            variant: `danger`,
          },
        );
        console.error(error);
      },
      showTime(dateValue) {
        return moment(dateValue).toDate();
      },
      static() {
        this.responseHistory.forEach(element => {
          let values = JSON.parse(element.New_Value__c);
          let indexes = Object.keys(values);
          this.finalData = [];
          element['isEmpty'] = true;
          for (let i = 0; i < this.rows; i++) {
            if (indexes.includes(i.toString()) && values[i] !== '') {
              this.finalData.push(values[i]);
              element['isEmpty'] = false;
            } else {
              this.finalData.push('');
            }
          }
          element.New_Value__c = element['isEmpty'] ? [''] : this.finalData;
        });
      },
      document() {
        this.finalData = [];
        let urls = [...new Set(this.responseHistory.map(element => element['New_Value__c']))];
        urls.forEach(url => {
          for (let el of this.responseHistory) {
            if (el['Field_Name__c'] === 'Saved Value-Long' && el['New_Value__c'] === url) {
              el['New_Value__c'] = location.protocol + '//' + location.host + el['New_Value__c'];
              this.finalData.push(el);
              break;
            }
          }
        });
        this.responseHistory = this.finalData;
      },
      multiPicklist() {
        this.responseHistory.forEach(element => {
          this.finalData = [];
          for (const index of this.options.keys()) {
            if (
              'New_Value__c' in element &&
              element.New_Value__c.includes(this.options[index]['Value__c'])
            ) {
              this.finalData.push(this.options[index]['Value__c']);
            }
          }
          element.New_Value__c = this.finalData;
        });
      },
    },
  };
</script>

<style scoped>
  .table thead th {
    background: #4a245e;
    border-right: 1px solid #ffffff;
    color: #ffffff;
    font-family: FSAlbert, serif;
    font-size: 18px;
    font-weight: normal;
  }
</style>
